import { handleActions } from 'redux-actions'

import { onPlayerChangeCurrentTimestamp, resetCurrentVideoTimestamp } from '../actions'

const defaultValue = -1.0

export default handleActions(
  {
    [onPlayerChangeCurrentTimestamp](state, { payload }) {
      return payload / 1000
    },
    [resetCurrentVideoTimestamp](state, { payload }) {
      return defaultValue
    },
  },
  defaultValue
)
